import {
  Stack,
  TextField,
  Button,
  Switch,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Card,
  CardHeader,
  Box,
  Autocomplete,
  Link,
  MenuItem,
  Tooltip,
  InputAdornment,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Alert,
  Menu,
  ListSubheader
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject
} from 'firebase/storage'
import {
  Add,
  AddPhotoAlternate,
  CommentsDisabled,
  ContactSupport,
  ContentCopy,
  Delete,
  Download,
  ExpandMore,
  HowToVote,
  MoreVert,
  PostAdd,
  Refresh,
  ReportGmailerrorred,
  RestartAlt,
  UploadFile,
  Verified
} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import {
  doc,
  setDoc,
  addDoc,
  arrayUnion,
  collection,
  increment,
  deleteField,
  query,
  where,
  getDocs,
  or,
  onSnapshot,
  arrayRemove,
  deleteDoc,
  updateDoc
} from 'firebase/firestore'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DateRange } from 'react-date-range'
import '../../Style/Form.css'
import { PaperComponent } from '../Helpers/Drag'
import MultiEmailComponent from '../Email/MultiEmailComponent'
import DownloadButton from '../Document/DownloadButton'
import Papa from 'papaparse'
import { icons, getIcon } from './Helpers/Icon.js'
import AdminHelpPulse from '../Support/AdminHelpPulse.js'
import RichTextEditorComponent from '../RichTextEditor/RichTextEditor.js'
import PulseSectionInputs from './Helpers/PulseSectionInput.js'

const UploadPulse = ({
  storage,
  db,
  uid,
  document = null,
  userEmail,
  isDraft = false,
  isCopy = false
}) => {
  const [viewCode, setViewCode] = useState('')
  const [useViewCode, setUseViewCode] = useState(false)

  const [displayName, setDisplayName] = useState('')
  const [hostName, setHostName] = useState('')
  const [contactInformation, setContactInformation] = useState('')
  const [contactLink, setContactLink] = useState('')
  const [useHostName, setUseHostName] = useState(false)
  const [useComments, setUseComments] = useState(true)
  const [commentVisibility, setCommentVisibility] = useState(false)
  const [searchable, setSearchable] = useState(false)
  const [signInView, setSignInView] = useState(true)

  const [description, setDescription] = useState('')

  const [fileName, setFileName] = useState('')

  const [logo, setLogo] = useState(null)
  const [logoPreview, setLogoPreview] = useState(null)
  const logoFileRef = useRef()

  const [alert, setAlert] = useState(null)
  const [loading, setLoading] = useState(false)

  const [comments, setComments] = useState([])

  const [isEdit, setIsEdit] = useState(false)
  const [logoChanged, setLogoChanged] = useState(false)
  const [logoDeleted, setLogoDeleted] = useState(false)
  const [adminEmails, setAdminEmails] = useState([])
  const [editEmails, setEditEmails] = useState([])
  const [minQuantity, setMinQuantity] = useState(null)
  const [customRoute, setCustomRoute] = useState('')
  const [customRouteVerified, setCustomRouteVerified] = useState('')

  const [logoAltered, setLogoAltered] = useState(null)
  const [selectedTeams, setSelectedTeams] = useState([])
  const [teams, setTeams] = useState([])

  const [noPaymentNeeded, setNoPaymentNeeded] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDeleteResponsesModal, setShowDeleteResponsesModal] =
    useState(false)

  const [sectionImages, setSectionImages] = useState({})
  const [alteredImages, setAlteredImages] = useState([])
  const imageRefs = useRef([])
  const abImageRefs = useRef({})
  const [showHelp, setShowHelp] = useState(false)
  const [showSubmitModal, setShowSubmitModal] = useState(false)
  const [thankYouMessage, setThankYouMessage] = useState('')

  const [allExpand, setAllExpand] = useState(true)

  const sectionTemplate = () => {
    return {
      title: '',
      subtitle: '',
      pulsePrompts: [''],
      pulseOptions: [
        { text: '', image: null, alt: null },
        { text: '', image: null, alt: null }
      ],
      pulseGrid: {
        rows: [''],
        columns: ['', '']
      },
      pulseChoice: [''],
      isABTesting: false,
      isMultipleChoice: false,
      isChoice: false,
      id: Math.random()
    }
  }
  const [pulseSections, setPulseSections] = useState([{ ...sectionTemplate() }])
  const [pulseValues, setPulseValues] = useState([
    'Strongly Disagree',
    'Disagree',
    'Neutral',
    'Agree',
    'Strongly Agree'
  ])
  const headerTemplate = {
    icon: '',
    title: ''
  }
  const [pulseHeaders, setPulseHeaders] = useState([{ ...headerTemplate }])
  const fileInputRef = useRef(null)
  const [importAlert, setImportAlert] = useState(null)
  const [areSectionsValid, setAreSectionsValid] = useState(false)
  const handleFileChange = e => {
    const file = e.target.files?.[0]
    if (!file) return

    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: results => {
        const sections = []
        let current = null
        const errors = []

        const TYPE_MAP = {
          SLIDER: { key: 'Prompt', label: 'a Prompt' },
          AB_TESTING: {
            key: 'Option',
            label: 'an Option',
            flag: 'isABTesting'
          },
          GRID: {
            key: ['GridRow', 'GridCol'],
            label: 'a GridRow or GridCol',
            flag: 'isMultipleChoice'
          },
          CHOICE: { key: 'Choice', label: 'a Choice', flag: 'isChoice' }
        }

        results.data.forEach((row, i) => {
          const [key, value] = [row[0]?.trim(), row[1]?.trim()]
          const line = i + 1

          if (!key || key === 'Key' || (key === 'Title' && value === '')) return

          if (key === 'Title') {
            if (current) sections.push(current)
            current = {
              ...sectionTemplate(),
              id: Math.random(),
              title: value,
              pulsePrompts: [],
              pulseOptions: [],
              pulseChoice: [],
              pulseGrid: { columns: [], rows: [] },
              _typeSet: null
            }
            return
          }

          if (!current) {
            errors.push(
              `Line ${line}: Row found before a "Title". Each section must start with a Title.`
            )
            return
          }

          if (key === 'Subtitle') {
            current.subtitle = value
            return
          }

          if (key === 'Type') {
            const config = TYPE_MAP[value]
            if (!config) {
              errors.push(
                `Line ${line}: Invalid Type "${value}". Expected SLIDER, AB_TESTING, GRID, or CHOICE.`
              )
              return
            }
            if (current._typeSet) {
              errors.push(
                `Line ${line}: Multiple types defined for one section.`
              )
              return
            }
            current._typeSet = value
            if (config.flag) current[config.flag] = true
            return
          }

          const typeConfig = TYPE_MAP[current._typeSet]
          if (!current._typeSet) {
            errors.push(
              `Line ${line}: You must define a "Type" before adding "${key}".`
            )
            return
          }

          const isAllowed = Array.isArray(typeConfig.key)
            ? typeConfig.key.includes(key)
            : typeConfig.key === key

          if (!isAllowed) {
            errors.push(
              `Line ${line}: Invalid row "${key}" for a ${current._typeSet} section. Expected ${typeConfig.label}.`
            )
            return
          }

          if (key === 'Prompt') current.pulsePrompts.push(value)
          if (key === 'Option')
            current.pulseOptions.push({
              text: `<p>${value}</p>`,
              image: null,
              alt: null
            })
          if (key === 'Choice') current.pulseChoice.push(`<p>${value}</p>`)
          if (key === 'GridRow') current.pulseGrid.rows.push(`<p>${value}</p>`)
          if (key === 'GridCol') current.pulseGrid.columns.push(value)
        })

        if (current) sections.push(current)

        if (errors.length > 0) {
          setImportAlert(
            <div style={{ textAlign: 'left' }}>
              <strong>Import failed with {errors.length} errors:</strong>
              <ul
                style={{
                  margin: '8px 0 0 0',
                  paddingLeft: '20px',
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}
              >
                {errors.slice(0, 15).map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
                {errors.length > 15 && (
                  <li>...and {errors.length - 15} more.</li>
                )}
              </ul>
            </div>
          )
          fileInputRef.current.value = null
          return
        }

        const cleaned = sections.map(s => {
          const final = { ...s }
          delete final._typeSet
          if (!final.pulsePrompts.length) final.pulsePrompts = null
          if (!final.pulseOptions.length) final.pulseOptions = null
          if (!final.pulseChoice.length) final.pulseChoice = null
          if (!final.pulseGrid.rows.length || !final.pulseGrid.columns.length)
            final.pulseGrid = null
          return final
        })

        setPulseSections(cleaned)
        setImportAlert(null)
        fileInputRef.current.value = null
      },
      error: () => {
        setImportAlert('Error parsing CSV file.')
        fileInputRef.current.value = null
      }
    })
  }

  const handleDownloadTemplate = () => {
    const rows = [
      ['Key', 'Value', 'Description / Instructions'],
      ['Title', 'Daily Pulse', 'Starts a new section. Always required first.'],
      ['Subtitle', 'How is your week going?', 'Optional sub-header text.'],
      ['Type', 'SLIDER', 'Types: SLIDER, AB_TESTING, GRID, or CHOICE.'],
      [
        'Prompt',
        'I feel productive today',
        'SLIDER sections use "Prompt" rows.'
      ],
      ['Title', 'Feature Preference', 'New section starts here.'],
      ['Type', 'AB_TESTING', 'AB_TESTING sections use "Option" rows.'],
      ['Option', 'Dark Mode', ''],
      ['Option', 'Light Mode', ''],
      ['Title', 'Feedback Grid', ''],
      ['Type', 'GRID', 'GRID sections use "GridRow" and "GridCol" rows.'],
      ['GridRow', 'Ease of use', ''],
      ['GridCol', 'Poor', ''],
      ['GridCol', 'Average', ''],
      ['GridCol', 'Great', ''],
      ['Title', 'Favorite Hobbies', ''],
      ['Type', 'CHOICE', 'CHOICE sections use "Choice" rows.'],
      ['Choice', 'Coding', ''],
      ['Choice', 'Design', '']
    ]

    const csvContent = rows
      .map(e => e.map(cell => `"${cell.replace(/"/g, '""')}"`).join(','))
      .join('\n')
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const link = window.document.createElement('a')
    link.href = url
    link.setAttribute('download', 'PulseSectionTemplate.csv')
    window.document.body.appendChild(link)
    link.click()
    window.document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  const handleButtonClick = () => {
    fileInputRef.current?.click()
  }
  const oneDay = 86400000
  const twoMB = 2097152

  const requirePayments = true

  var dateToday = new Date()
  var date = new Date(dateToday.getTime() + oneDay * 29)

  const [state, setState] = useState([
    {
      startDate: dateToday,
      endDate: date,
      key: 'selection'
    }
  ])

  const [state2, setState2] = useState([
    {
      startDate: dateToday,
      endDate: date,
      key: 'selection'
    }
  ])

  useEffect(() => {
    if (pulseSectionsAreValid()) {
      setAreSectionsValid(true)
    } else {
      setAreSectionsValid(false)
    }
  }, [pulseSections])

  const pulseSectionsAreValid = () => {
    for (let section of pulseSections) {
      if (!section.title) {
        return false
      }
      if (
        !section.isABTesting &&
        !section.isMultipleChoice &&
        !section.isChoice
      ) {
        for (let prompt of section.pulsePrompts) {
          if (!prompt) {
            return false
          }
        }
      } else if (section.isABTesting) {
        const texts = section.pulseOptions.map(option => option.text)

        if (texts.some(text => !text || text.trim() === '<p></p>')) {
          return false
        }

        const uniqueTexts = new Set(texts)
        if (uniqueTexts.size !== texts.length) {
          return false
        }
      } else if (section.isMultipleChoice) {
        let rowsGood = section.pulseGrid.rows.every(
          row => row && row.trim() !== '' && row.trim() !== '<p></p>'
        )
        let colsGood = section.pulseGrid.columns.every(
          col => col && col.trim() !== ''
        )
        if (!rowsGood || !colsGood) {
          return false
        }
        const uniqueCols = new Set(section.pulseGrid.columns)
        if (uniqueCols.size !== section.pulseGrid.columns.length) {
          return false
        }
      } else {
        const texts = section.pulseChoice

        if (texts.some(text => !text || text.trim() === '<p></p>')) {
          return false
        }

        const uniqueTexts = new Set(texts)
        if (uniqueTexts.size !== texts.length) {
          return false
        }
      }
      if (pulseHeaders[0].title && pulseHeaders[0].icon) {
        if (!section.header || !section.header.icon || !section.header.title) {
          return false
        }
      }
    }
    return true
  }

  function getDate (date) {
    return new Date(date.toDate())
  }

  async function getTeams () {
    let q = query(
      collection(db, 'teams'),
      or(
        where('creator', '==', uid),
        where('emails', 'array-contains', userEmail)
      )
    )
    const documentSnapshots = await getDocs(q)
    let teams_ = []
    documentSnapshots.forEach(val => {
      teams_.push({ ...val.data(), id: val.id })
    })
    setTeams(teams_)
  }

  function quantityOfDates (start, end) {
    const diffTime = Math.abs(start - end)
    const quantity = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
    return quantity
  }

  useEffect(() => {
    if (document) {
      if (document.commentDate) {
        setUseComments(true)
        setCommentVisibility(document.commentVisibility || false)
      }
      setMinQuantity(0)

      if (!isCopy) {
        setCustomRoute(document.customRoute || '')
        setCustomRouteVerified(document.customRoute !== '')
        setIsEdit(true)
        setFileName(document.fileName)
        setState([
          {
            key: document.visibleDate.key,
            startDate: getDate(document.visibleDate.startDate),
            endDate: getDate(document.visibleDate.endDate)
          }
        ])

        if (document.paidQuantity) {
          setMinQuantity(parseInt(document.paidQuantity))
        }
        setComments(document.comments || [])
        setEditEmails(document.adminEmails || [])
        if (document.logoURL) {
          setLogoPreview(document.logoURL)
          setLogoAltered(document.logoURL)
        }
        if (document.commentDate) {
          setState2([
            {
              key: document.commentDate.key,
              startDate: getDate(document.commentDate.startDate),
              endDate: getDate(document.commentDate.endDate)
            }
          ])
        }
        if (document.sectionImages) {
          setSectionImages(
            Object.keys(document.sectionImages).map(key => {
              return {
                file: null,
                preview: document.sectionImages[key],
                alt:
                  document.sectionImageAlts && document.sectionImageAlts[key]
                    ? document.sectionImageAlts[key]
                    : ''
              }
            })
          )
        }
      }

      setDisplayName(document.displayName)
      setContactInformation(document.contactInformation)
      setContactLink(document.contactLink || '')
      setDescription(document.description)
      setSearchable(document.searchable)
      setSignInView(
        typeof document.signInView !== 'undefined' ? document.signInView : true
      )

      setAdminEmails(document.adminEmails || [])
      if (document.hostName) {
        setUseHostName(true)
        setHostName(document.hostName)
      }
      if (document.viewCode) {
        setUseViewCode(true)
        setViewCode(document.viewCode)
      }
      if (document.thankYouMessage) {
        setThankYouMessage(document.thankYouMessage)
      }

      if (document.pulseValues) {
        setPulseValues(document.pulseValues)
      }
      if (document.pulseSections) {
        let sections = document.pulseSections
        if (document.optionImages) {
          sections = sections.map((sec, index) => {
            if (sec.isABTesting) {
              sec.pulseOptions = sec.pulseOptions.map((opt, optIndex) => {
                if (document.optionImages[`sec${index}_opt${optIndex}`]) {
                  opt.preview =
                    document.optionImages[`sec${index}_opt${optIndex}`]
                  opt.image = null
                }
                return opt
              })
            }
            if (!sec.id) {
              sec.id = Math.random()
            }
            return sec
          })
        }
        setPulseSections(sections)
      }
      if (document.pulseHeaders) {
        setPulseHeaders(document.pulseHeaders)
      }
    }
    if (uid && userEmail) {
      getTeams()
    }
  }, [uid, document, userEmail])

  useEffect(() => {
    async function getNoPayment () {
      let noPaymentSnap = await getDocs(collection(db, 'paymentConfig'))
      let paymentBool = false
      noPaymentSnap.forEach(val => {
        let data = val.data()
        let domains = data.domains
        let ids = data.ids
        let inDomains = domains.reduce((acc, curr) => {
          return acc || userEmail.includes(curr)
        }, false)
        let inIds = ids.includes(uid)
        paymentBool = paymentBool || inIds || inDomains
      })
      setNoPaymentNeeded(paymentBool)
    }
    if (db) {
      getNoPayment()
    } else {
      setNoPaymentNeeded(false)
    }
  }, [db])

  const navigate = useNavigate()

  function makeid (length) {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!?$%&'
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
      counter += 1
    }
    return result
  }

  const handleLogoChange = e => {
    if (e.target.files) {
      var file = e.target.files[0]
      if (file.size < twoMB) {
        setLogo(file)
        setLogoPreview(URL.createObjectURL(file))
        setLogoChanged(true)
        setAlert(null)
      } else {
        setAlert('Logo must be smaller than 2MB')
      }
    }
  }

  const handleLogoRemove = () => {
    setLogo(null)
    setLogoPreview(null)
    logoAltered && setLogoDeleted(true)
    if (logoFileRef.current) {
      logoFileRef.current.value = ''
      logoFileRef.current.type = 'text'
      logoFileRef.current.type = 'file'
    }
  }

  const handleImageRemove = index => {
    let newImages = { ...sectionImages }
    if (newImages[index]) {
      if (newImages[index].file === null && newImages[index].preview) {
        setAlteredImages([newImages[index].preview, ...alteredImages])
      }
      delete newImages[index]
      setSectionImages(newImages)
      if (imageRefs.current[index]) {
        imageRefs.current[index].value = ''
        imageRefs.current[index].type = 'text'
        imageRefs.current[index].type = 'file'
      }
    }
  }

  const handleABImageRemove = (
    section,
    setSection,
    sectionIndex,
    optionIndex,
    filter
  ) => {
    const targetOption = section.pulseOptions[optionIndex]

    if (targetOption) {
      if (targetOption.image === null && targetOption.preview) {
        setAlteredImages([targetOption.preview, ...alteredImages])
      }

      setSection(prev => {
        let updatedOptions = prev.pulseOptions.map((opt, oIdx) => {
          if (oIdx !== optionIndex) return opt
          return { ...opt, image: null, preview: null, alt: null }
        })

        if (filter) {
          updatedOptions = updatedOptions.filter((_, i) => i !== optionIndex)
        }

        return { ...prev, pulseOptions: updatedOptions }
      })
    }

    const ref =
      abImageRefs.current[`section${sectionIndex}_option${optionIndex}`]
    if (ref) {
      ref.value = ''
      ref.type = 'text'
      ref.type = 'file'
    }
  }

  const handleSectionImageDelete = sectionIndex => {
    let newSectionImages = { ...sectionImages }
    let newAlteredImages = [...alteredImages]
    let updatedPulseSections = [...pulseSections]
    let _sec = pulseSections[sectionIndex]

    if (newSectionImages[sectionIndex]) {
      if (
        newSectionImages[sectionIndex].file === null &&
        newSectionImages[sectionIndex].preview
      ) {
        newAlteredImages.unshift(newSectionImages[sectionIndex].preview)
      }
      delete newSectionImages[sectionIndex]

      if (imageRefs.current[sectionIndex]) {
        imageRefs.current[sectionIndex].value = ''
        imageRefs.current[sectionIndex].type = 'text'
        imageRefs.current[sectionIndex].type = 'file'
      }
    }

    if (_sec.isABTesting) {
      _sec.pulseOptions.forEach((opt, optionIndex) => {
        if (opt.preview) {
          if (opt.image === null) {
            newAlteredImages.unshift(opt.preview)
          }

          updatedPulseSections[sectionIndex].pulseOptions[optionIndex] = {
            ...updatedPulseSections[sectionIndex].pulseOptions[optionIndex],
            image: null,
            preview: null,
            alt: null
          }

          const ref =
            abImageRefs.current[`section${sectionIndex}_option${optionIndex}`]
          if (ref) {
            ref.value = ''
            ref.type = 'text'
            ref.type = 'file'
          }
        }
      })
    }

    setSectionImages(newSectionImages)
    setAlteredImages(newAlteredImages)
    setPulseSections(updatedPulseSections.filter((_, i) => i !== sectionIndex))
  }

  const handleAllDelete = () => {
    let newSectionImages = { ...sectionImages }
    let newAlteredImages = [...alteredImages]
    let updatedPulseSections = [...pulseSections]

    pulseSections.forEach((_sec, sectionIndex) => {
      if (newSectionImages[sectionIndex]) {
        if (
          newSectionImages[sectionIndex].file === null &&
          newSectionImages[sectionIndex].preview
        ) {
          newAlteredImages.unshift(newSectionImages[sectionIndex].preview)
        }
        delete newSectionImages[sectionIndex]

        if (imageRefs.current[sectionIndex]) {
          imageRefs.current[sectionIndex].value = ''
          imageRefs.current[sectionIndex].type = 'text'
          imageRefs.current[sectionIndex].type = 'file'
        }
      }

      if (_sec.isABTesting) {
        _sec.pulseOptions.forEach((opt, optionIndex) => {
          if (opt.preview) {
            if (opt.image === null) {
              newAlteredImages.unshift(opt.preview)
            }

            updatedPulseSections[sectionIndex].pulseOptions[optionIndex] = {
              ...updatedPulseSections[sectionIndex].pulseOptions[optionIndex],
              image: null,
              preview: null,
              alt: null
            }

            const ref =
              abImageRefs.current[`section${sectionIndex}_option${optionIndex}`]
            if (ref) {
              ref.value = ''
              ref.type = 'text'
              ref.type = 'file'
            }
          }
        })
      }
    })

    setSectionImages(newSectionImages)
    setAlteredImages(newAlteredImages)
    setPulseSections([{ ...sectionTemplate() }])
  }

  const handleImageChange = (index, e) => {
    if (e.target.files) {
      var file = e.target.files[0]
      let newImages = { ...sectionImages }
      newImages[index] = {
        file: file,
        preview: URL.createObjectURL(file),
        alt: ''
      }
      setSectionImages(newImages)
      setAlteredImages(['added', ...alteredImages])
    }
  }

  const handleABImageChange = (optionIndex, setSection, e) => {
    if (e.target.files) {
      var file = e.target.files[0]
      var preview = URL.createObjectURL(file)
      setSection(prev => ({
        ...prev,
        pulseOptions: prev.pulseOptions.map((opt, i) => {
          if (i !== optionIndex) return opt
          return { ...opt, image: file, preview: preview }
        })
      }))
      setAlteredImages(['added', ...alteredImages])
    }
  }

  const handleImageAltChange = (index, e) => {
    let newImages = { ...sectionImages }
    if (newImages[index]) {
      newImages[index].alt = e.target.value
      setSectionImages(newImages)
    }
  }

  function onlyUnique (value, index, array) {
    return array.indexOf(value) === index
  }

  const handleChangeSelectedTeams = (event, newSelectedTeams) => {
    let oldSelected = []
    selectedTeams.forEach(
      val => (oldSelected = [...oldSelected, ...val.emails])
    )
    let newEmails = adminEmails.filter(val => !oldSelected.includes(val))
    newSelectedTeams.forEach(val => (newEmails = [...newEmails, ...val.emails]))
    setSelectedTeams(newSelectedTeams)
    setAdminEmails(
      newEmails.filter(val => val !== userEmail).filter(onlyUnique)
    )
  }

  const handleCode = event => {
    const value = event.target.value
    setViewCode(value)
  }

  const handleCustomRoute = event => {
    let value = event.target.value
    value = value.replace(/[^A-Za-z0-9]/g, '_')
    setCustomRoute(value.toLowerCase())
    setCustomRouteVerified(false)
  }

  useEffect(() => {
    checkCustomRoute()
  }, [customRoute])

  const checkCustomRoute = async () => {
    if (customRoute !== '') {
      let q1 = query(
        collection(db, 'sliders'),
        where('customRoute', '==', customRoute)
      )
      const querySnapshot = await getDocs(q1)
      if (querySnapshot.docs.length === 0) {
        setCustomRouteVerified(true)
      } else {
        setCustomRouteVerified(false)
        if (isEdit && document) {
          querySnapshot.forEach(doc => {
            if (doc.id === document.id) {
              setCustomRouteVerified(true)
            }
          })
        }
      }
    }
  }

  const handleFileName = event => {
    const value = event.target.value
    setFileName(value)
  }
  const handleDisplayName = event => {
    const value = event.target.value
    setDisplayName(value)
  }
  const handleHostName = event => {
    const value = event.target.value
    setHostName(value)
  }
  const handleDescription = value => {
    setDescription(value)
  }
  const handleContact = event => {
    const value = event.target.value
    setContactInformation(value)
  }
  const handleContactLink = event => {
    const value = event.target.value
    setContactLink(value)
  }
  const changeDate2 = item => {
    if (
      item.selection.startDate >= state[0].startDate &&
      item.selection.endDate <= state[0].endDate
    )
      setState2([item.selection])
  }
  const matchDates = () => {
    setState2(state)
  }

  const getObject = () => {
    var obj = {
      fileName: fileName,
      uid: uid,
      displayName: displayName,
      contactInformation: contactInformation,
      description: description,
      visibleDate: state[0],
      searchable: searchable,
      adminEmails: adminEmails,
      editDate: Date.now(),
      contactLink: contactLink,
      signInView: signInView,
      customRoute: customRoute,
      pulseSections: pulseSections.reduce((acc, section) => {
        if (
          pulseHeaders.length === 1 &&
          pulseHeaders[0].icon === '' &&
          pulseHeaders[0].title === ''
        ) {
          section.header = null
        }
        const newSection = {
          ...section,
          pulsePrompts:
            section.isABTesting || section.isMultipleChoice || section.isChoice
              ? null
              : section.pulsePrompts,
          pulseOptions: section.isABTesting
            ? section.pulseOptions.map(opt => ({
                ...opt,
                image: null,
                preview: null,
                alt: opt.alt === '' ? null : opt.alt
              }))
            : null,
          pulseGrid: section.isMultipleChoice ? section.pulseGrid : null,
          pulseChoice: section.isChoice ? section.pulseChoice : null
        }

        acc.push(newSection)
        return acc
      }, []),
      pulseValues: pulseValues
    }
    obj.pulseHeaders = pulseHeaders

    if (thankYouMessage && thankYouMessage.trim() !== '') {
      obj.thankYouMessage = thankYouMessage
    } else {
      if (isEdit && !isCopy) {
        obj.thankYouMessage = deleteField()
      }
    }

    if (useComments) {
      obj.commentDate = state2[0]
      obj.comments = comments || []
      obj.commentCount = comments.length || 0
      obj.commentVisibility = commentVisibility
    } else {
      if (isEdit && !isCopy) {
        obj.commentDate = deleteField()
        obj.comments = deleteField()
        obj.commentCount = deleteField()
        obj.commentVisibility = deleteField()
      }
    }
    if (useHostName) {
      obj.hostName = hostName
    } else {
      if (isEdit && !isCopy) {
        obj.hostName = deleteField()
      }
    }
    if (useViewCode) {
      obj.viewCode = viewCode
    } else {
      if (isEdit && !isCopy) {
        obj.viewCode = deleteField()
      }
    }

    if (sectionImages && Object.keys(sectionImages).length > 0) {
      let fileAlts = {}
      Object.keys(sectionImages).forEach(key => {
        if (sectionImages[key].alt) {
          fileAlts[key] = sectionImages[key].alt
        }
      })
      obj.sectionImageAlts = fileAlts
    }

    return obj
  }

  function getRandomInt (max) {
    return Math.floor(Math.random() * max)
  }

  function createAdminObject (id) {
    let obj = {}
    obj.to = adminEmails
    obj.message = {
      subject:
        'You have been invited to be an admin for a pulse on Community Document',
      html:
        `Check out ${fileName} here: <a href='${
          window.location.origin + '/viewPulse/' + id
        }' target='_blank'>
            ${window.location.host + '/viewPulse/' + id}
          </a>` +
        (viewCode !== null && useViewCode
          ? '. Use Access Code: "' + viewCode + '".'
          : '') +
        ' Please use this email address when signing up or signing in, or ask the creator to add your correct email. Sign up for a paid version.'
    }
    return obj
  }

  const handleRemoveResponses = async () => {
    if (uid === document.uid) {
      setLoading(true)

      setComments([])

      await setDoc(
        doc(db, 'sliders', document.id),
        {
          comments: deleteField(),
          commentCount: 0
        },
        { merge: true }
      )
        .then(() => {
          setShowDeleteResponsesModal(false)
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
          console.error('Error removing responses: ', error)
        })
    }
  }

  const handleRemoveDoc = async () => {
    if (uid === document.uid) {
      setLoading(true)
      await deleteDoc(doc(db, 'sliders', document.id))
        .then(async () => {
          let promises = []

          if (document.logoURL) {
            promises.push(
              deleteObject(ref(storage, document.logoURL))
                .then(() => {})
                .catch(() => {})
            )
          }

          if (document.sectionImages) {
            Object.keys(document.sectionImages).forEach(key => {
              if (document.sectionImages[key]) {
                promises.push(
                  deleteObject(ref(storage, document.sectionImages[key]))
                    .then(() => {})
                    .catch(() => {})
                )
              }
            })
          }

          if (document.optionImages) {
            Object.keys(document.optionImages).forEach(key => {
              if (document.optionImages[key]) {
                promises.push(
                  deleteObject(ref(storage, document.optionImages[key]))
                    .then(() => {})
                    .catch(() => {})
                )
              }
            })
          }

          let q1 = query(
            collection(db, 'users'),
            where('pulseIds', 'array-contains', document.id)
          )
          const querySnapshot = await getDocs(q1)
          querySnapshot.forEach(async docRef => {
            promises.push(
              await setDoc(
                doc(db, 'users', docRef.id),
                {
                  pulseIds: arrayRemove(docRef.id),
                  pulseCount: increment(-1)
                },
                {
                  merge: true
                }
              )
            )
          })

          await Promise.all(promises)

          navigate('/dashboard')
        })
        .catch(error => {
          setLoading(false)
          console.error('Error removing pulse: ', error)
        })
    }
  }

  const editDoc = async () => {
    setShowSubmitModal(false)
    if (document && document.id) {
      const docRef = doc(db, 'sliders', document.id)
      setLoading(true)

      if (logoChanged) {
        const uploadLogoTask = uploadBytesResumable(
          ref(storage, `${uid}/${fileName}_logo_${getRandomInt(10000)}`),
          logo
        )
        uploadLogoTask.on(
          'state_changed',
          snapshot => {},
          error => {
            setAlert('Error adding logo, please try again')
            setLoading(false)
          },
          () => {
            getDownloadURL(uploadLogoTask.snapshot.ref).then(
              async downloadLogoURL => {
                await setDoc(
                  docRef,
                  {
                    logoURL: downloadLogoURL
                  },
                  { merge: true }
                )
              }
            )
          }
        )
      }

      if (alteredImages.length > 0) {
        let promises = []
        let fileLinks = {}
        let optionLinks = {}
        for (let sec in pulseSections) {
          if (pulseSections[sec].isABTesting) {
            for (let option in pulseSections[sec].pulseOptions) {
              if (pulseSections[sec].pulseOptions[option].image) {
                const uploadLogoTask = uploadBytesResumable(
                  ref(
                    storage,
                    `${uid}/${fileName}_abTesting_section${sec}_option_${option}${getRandomInt(
                      10000
                    )}`
                  ),
                  pulseSections[sec].pulseOptions[option].image
                )
                promises.push(
                  new Promise((resolve, reject) => {
                    uploadLogoTask.on(
                      'state_changed',
                      snapshot => {},
                      error => {
                        setAlert('Error adding logo, please try again')
                        setLoading(false)
                      },
                      () => {
                        getDownloadURL(uploadLogoTask.snapshot.ref).then(
                          async downloadLogoURL => {
                            optionLinks[`sec${sec}_opt${option}`] =
                              downloadLogoURL
                            resolve()
                          }
                        )
                      }
                    )
                  })
                )
              } else if (
                pulseSections &&
                pulseSections[sec] &&
                pulseSections[sec] &&
                pulseSections[sec].pulseOptions &&
                pulseSections[sec].pulseOptions[option] &&
                pulseSections[sec].pulseOptions[option].preview &&
                !alteredImages.includes(
                  pulseSections[sec].pulseOptions[option].preview
                )
              ) {
                optionLinks[`sec${sec}_opt${option}`] =
                  pulseSections[sec].pulseOptions[option].preview
              } else {
                optionLinks[`sec${sec}_opt${option}`] = null
              }
            }
          }
        }
        if (Object.keys(sectionImages).length > 0) {
          for (let key of Object.keys(sectionImages)) {
            if (sectionImages[key] && sectionImages[key].file) {
              let image = sectionImages[key].file
              const uploadLogoTask = uploadBytesResumable(
                ref(
                  storage,
                  `${uid}/${docRef.id}_image_${key}_${getRandomInt(10000)}`
                ),
                image
              )
              promises.push(
                new Promise((resolve, reject) => {
                  uploadLogoTask.on(
                    'state_changed',
                    snapshot => {},
                    error => {
                      setAlert('Error adding Images, please try again')
                      setLoading(false)
                      reject(error)
                    },
                    () => {
                      getDownloadURL(uploadLogoTask.snapshot.ref).then(
                        async downloadLogoURL => {
                          fileLinks[key] = downloadLogoURL
                          resolve()
                        }
                      )
                    }
                  )
                })
              )
            } else if (
              sectionImages &&
              sectionImages[key] &&
              sectionImages[key].preview &&
              !alteredImages.includes(sectionImages[key].preview)
            ) {
              fileLinks[key] = sectionImages[key].preview
            } else {
              fileLinks[key] = null
            }
          }
        }
        if (promises.length > 0) {
          await Promise.all(promises).then(async () => {
            await updateDoc(doc(db, 'sliders', docRef.id), {
              sectionImages: fileLinks,
              optionImages: optionLinks
            })
          })
        } else {
          await updateDoc(doc(db, 'sliders', docRef.id), {
            sectionImages: fileLinks,
            optionImages: optionLinks
          })
        }
        alteredImages.forEach(image => {
          if (image && image !== 'added') {
            deleteObject(ref(storage, image))
              .then(() => {})
              .catch(() => {})
          }
        })
      }

      if (logoDeleted) {
        deleteObject(ref(storage, logoAltered))
          .then(() => {})
          .catch(() => {})
        if (!logoChanged) {
          await setDoc(
            docRef,
            {
              logoURL: deleteField()
            },
            { merge: true }
          )
        }
      }

      if (adminEmails.length > 0 && adminEmails !== editEmails) {
        await addDoc(collection(db, 'mail'), createAdminObject(docRef.id))
      }

      await setDoc(
        docRef,
        {
          ...getObject(),
          draft:
            minQuantity === null
              ? true
              : minQuantity !==
                quantityOfDates(state[0].startDate, state[0].endDate)
        },
        {
          merge: true
        }
      ).then(() => {
        if (
          minQuantity !== null &&
          minQuantity === quantityOfDates(state[0].startDate, state[0].endDate)
        ) {
          navigate(
            '/viewPulse/' + (customRoute.length > 0 ? customRoute : docRef.id)
          )
        } else {
          checkout(docRef.id)
        }
      })
    }
  }

  async function checkout (documentId) {
    if (noPaymentNeeded || !requirePayments) {
      await setDoc(
        doc(db, 'sliders', documentId),
        {
          draft: false
        },
        {
          merge: true
        }
      ).then(() => {
        navigate(
          '/viewPulse/' + (customRoute.length > 0 ? customRoute : documentId)
        )
      })
    } else {
      let quantity = quantityOfDates(state[0].startDate, state[0].endDate)

      if (minQuantity !== null) {
        quantity -= minQuantity
      }

      let docRef = await addDoc(
        collection(db, 'customers', uid, 'checkout_sessions'),
        {
          mode: 'payment',
          price: 'price_1RdcQ801d38yDsADJv4JiQem',
          quantity: quantity,
          allow_promotion_codes: true,
          success_url:
            window.location.origin +
            '/viewPulse/' +
            (customRoute.length > 0 ? customRoute : documentId),
          cancel_url: window.location.origin + '/draftPulse/' + documentId,
          metadata: {
            item: documentId,
            paidQuantity: parseInt(parseInt(minQuantity) + quantity)
          }
        }
      )
      if (docRef) {
        const unsub = onSnapshot(
          doc(db, 'customers', uid, 'checkout_sessions', docRef.id),
          snap => {
            const { error, url } = snap.data()
            if (error) {
              unsub()
              window.alert(`An error occured: ${error.message}`)
              setLoading(false)
            }
            if (url) {
              unsub()
              setLoading(false)
              window.location.assign(url)
            }
          }
        )
      }
    }
  }

  const submitDoc = async () => {
    setLoading(true)
    setShowSubmitModal(false)

    try {
      await addDoc(collection(db, 'sliders'), {
        ...getObject(),
        createDate: Date.now(),
        draft: true
      }).then(async docRef => {
        if (logo !== null) {
          const uploadLogoTask = uploadBytesResumable(
            ref(storage, `${uid}/${fileName}_logo_${getRandomInt(10000)}`),
            logo
          )
          uploadLogoTask.on(
            'state_changed',
            snapshot => {},
            error => {
              setAlert('Error adding logo, please try again')
              setLoading(false)
            },
            () => {
              getDownloadURL(uploadLogoTask.snapshot.ref).then(
                async downloadLogoURL => {
                  await setDoc(
                    doc(db, 'sliders', docRef.id),
                    {
                      logoURL: downloadLogoURL
                    },
                    { merge: true }
                  )
                }
              )
            }
          )
        }

        let promises = []
        let fileLinks = {}
        let optionLinks = {}
        for (let sec in pulseSections) {
          if (pulseSections[sec].isABTesting) {
            for (let option in pulseSections[sec].pulseOptions) {
              if (pulseSections[sec].pulseOptions[option].image) {
                const uploadLogoTask = uploadBytesResumable(
                  ref(
                    storage,
                    `${uid}/${fileName}_abTesting_section${sec}_option_${option}${getRandomInt(
                      10000
                    )}`
                  ),
                  pulseSections[sec].pulseOptions[option].image
                )
                promises.push(
                  new Promise((resolve, reject) => {
                    uploadLogoTask.on(
                      'state_changed',
                      snapshot => {},
                      error => {
                        setAlert('Error adding logo, please try again')
                        setLoading(false)
                      },
                      () => {
                        getDownloadURL(uploadLogoTask.snapshot.ref).then(
                          async downloadLogoURL => {
                            optionLinks[`sec${sec}_opt${option}`] =
                              downloadLogoURL
                            resolve()
                          }
                        )
                      }
                    )
                  })
                )
              }
            }
          }
        }

        if (Object.keys(sectionImages).length > 0) {
          for (let key of Object.keys(sectionImages)) {
            if (sectionImages[key] && sectionImages[key].file) {
              let image = sectionImages[key].file
              const uploadLogoTask = uploadBytesResumable(
                ref(
                  storage,
                  `${uid}/${docRef.id}_image_${key}_${getRandomInt(10000)}`
                ),
                image
              )
              promises.push(
                new Promise((resolve, reject) => {
                  uploadLogoTask.on(
                    'state_changed',
                    snapshot => {},
                    error => {
                      setAlert('Error adding Images, please try again')
                      setLoading(false)
                      reject(error)
                    },
                    () => {
                      getDownloadURL(uploadLogoTask.snapshot.ref).then(
                        async downloadLogoURL => {
                          fileLinks[key] = downloadLogoURL
                          resolve()
                        }
                      )
                    }
                  )
                })
              )
            }
          }
        }
        if (promises.length > 0) {
          await Promise.all(promises).then(async () => {
            await setDoc(
              doc(db, 'sliders', docRef.id),
              {
                sectionImages: fileLinks,
                optionImages: optionLinks
              },
              { merge: true }
            )
          })
        }
        if (adminEmails.length > 0) {
          await addDoc(collection(db, 'mail'), createAdminObject(docRef.id))
        }
        await setDoc(
          doc(db, 'users', uid),
          {
            pulseIds: arrayUnion(docRef.id),
            pulseCount: increment(1)
          },
          { merge: true }
        )
        checkout(docRef.id)
      })
    } catch (error) {
      console.error('Error submitting pulse: ', error)
      if (!alert) {
        setAlert('Error uploading pulse, please try again')
      }
      setLoading(false)
    }
  }

  const clearSectionHeaders = () => {
    setPulseSections(
      pulseSections.map(section => {
        return { ...section, header: null }
      })
    )
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const openMenu = Boolean(anchorEl)
  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleOpenMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <div style={{ paddingTop: '20px', paddingBottom: 2 }}>
      <Stack
        direction='column'
        justifyContent='center'
        alignItems='center'
        spacing={3}
        sx={{
          m: 'auto',
          mb: 4
        }}
      >
        <Card raised sx={{ width: '100%', maxWidth: 'min(1000px, 95%)' }}>
          <CardHeader
            title={
              isEdit
                ? isDraft
                  ? 'Finish Pulse Upload'
                  : 'Edit Pulse'
                : 'Pulse Information'
            }
            action={
              <Tooltip title='Pulse Upload Directions'>
                <IconButton
                  sx={{ placeSelf: 'end' }}
                  color='info'
                  onClick={() => setShowHelp(true)}
                >
                  <ContactSupport />
                </IconButton>
              </Tooltip>
            }
          />
          <Stack
            direction='column'
            justifyContent='center'
            alignItems='center'
            spacing={1}
            sx={{ width: '97%', m: 'auto', pb: 2 }}
          >
            <TextField
              id='file name'
              label='Pulse Name'
              variant='outlined'
              onChange={handleFileName}
              fullWidth
              disabled={loading}
              value={fileName}
              inputProps={{ maxLength: 200 }}
              required
              autoFocus
            />
            <TextField
              id='displayName'
              variant='outlined'
              label='Organization Name'
              onChange={handleDisplayName}
              value={displayName}
              disabled={loading}
              fullWidth
              required
            />

            <input
              style={{ display: 'none' }}
              ref={logoFileRef}
              id='logo'
              type='file'
              accept='.png, .jpg, .jpeg'
              onChange={handleLogoChange}
            />
            {logoPreview !== null ? (
              <Stack alignItems='center'>
                <img
                  style={{
                    height: '100px',
                    margin: '10px',
                    objectFit: 'contain'
                  }}
                  src={logoPreview}
                  className='logoUpload'
                  alt='logo preview'
                />
                <Button
                  variant='contained'
                  onClick={handleLogoRemove}
                  disabled={loading}
                  color='error'
                  startIcon={<Delete />}
                >
                  Remove Logo
                </Button>
              </Stack>
            ) : (
              <Button
                variant='contained'
                onClick={() => logoFileRef.current.click()}
                disabled={loading}
                startIcon={<AddPhotoAlternate />}
              >
                Upload Logo
              </Button>
            )}

            <Stack direction='row' alignItems='center'>
              <h5 style={{ margin: '0' }}>Host Name</h5>
              <Switch
                checked={useHostName}
                onChange={() => {
                  setUseHostName(!useHostName)
                }}
              />
            </Stack>
            {useHostName && (
              <TextField
                id='hostName'
                label='Host Name'
                variant='outlined'
                onChange={handleHostName}
                value={hostName}
                fullWidth
                disabled={loading}
                required
              />
            )}

            <RichTextEditorComponent
              label='Description'
              onChange={handleDescription}
              disabled={loading}
              value={description}
              keyValue={'pulse_desctiption_rte'}
            />

            <TextField
              id='contact information'
              label='Contact Information'
              variant='outlined'
              onChange={handleContact}
              disabled={loading}
              fullWidth
              value={contactInformation}
              inputProps={{ maxLength: 200 }}
            />

            <TextField
              id='contact link'
              label='Contact Link'
              variant='outlined'
              onChange={handleContactLink}
              disabled={loading}
              fullWidth
              value={contactLink}
              inputProps={{ maxLength: 200 }}
            />
            {contactLink.length > 0 && (
              <span
                className='caption'
                style={{ margin: '0', marginTop: '10px' }}
              >
                Include full link like:
                "https://communitydocument.com/support/contact"
              </span>
            )}
          </Stack>
        </Card>
        <Card raised sx={{ width: '100%', maxWidth: 'min(1000px, 95%)' }}>
          <CardHeader
            title='Pulse Details'
            action={
              <Tooltip title='Pulse Upload Directions'>
                <IconButton
                  sx={{ placeSelf: 'end' }}
                  color='info'
                  onClick={() => setShowHelp(true)}
                >
                  <ContactSupport />
                </IconButton>
              </Tooltip>
            }
          />
          <Stack
            direction='column'
            justifyContent='center'
            alignItems='center'
            spacing={1}
            sx={{ width: '97%', m: 'auto', pb: 2 }}
          >
            <Accordion sx={{ width: '100%', marginBlock: 1 }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                Pulse Headers
              </AccordionSummary>
              <AccordionDetails>
                Group Pulse Sections under a header that includes a title and an
                icon.
                <br />
                <br />
                <Stack spacing={1}>
                  {pulseHeaders.map((val, index) => (
                    <Stack
                      direction='row'
                      alignItems='center'
                      sx={{ width: '100%' }}
                      key={index + '_pulseHeader'}
                    >
                      <TextField
                        select
                        label='Icon'
                        size='small'
                        sx={{ width: '125px' }}
                        disabled={loading}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              {val.icon && <>{getIcon(val.icon)}</>}
                            </InputAdornment>
                          )
                        }}
                        value={''}
                      >
                        <div style={{ maxWidth: '300px' }}>
                          {icons
                            .filter(
                              val =>
                                !pulseHeaders.find(
                                  header => val.icon === header.icon
                                )
                            )
                            .map(option => (
                              <IconButton
                                key={option.icon + '_pulseHeader_icon' + index}
                                onClick={() => {
                                  clearSectionHeaders()
                                  let newHeaderValues = [...pulseHeaders]
                                  newHeaderValues[index].icon = option.icon
                                  setPulseHeaders(newHeaderValues)
                                  clearSectionHeaders()
                                }}
                              >
                                {getIcon(option.icon)}
                              </IconButton>
                            ))}
                        </div>
                      </TextField>
                      <TextField
                        label={`Pulse Header ${index + 1}`}
                        variant='outlined'
                        onChange={e => {
                          clearSectionHeaders()
                          let newHeaderValues = [...pulseHeaders]
                          newHeaderValues[index].title = e.target.value
                          setPulseHeaders(newHeaderValues)
                        }}
                        disabled={loading}
                        size='small'
                        fullWidth
                        value={val.title}
                        sx={{ mr: 1, ml: 1 }}
                      />
                      <IconButton
                        variant='outlined'
                        onClick={() => {
                          if (pulseHeaders.length <= 1) {
                            setPulseHeaders([{ ...headerTemplate }])
                            return
                          }
                          setPulseHeaders(
                            pulseHeaders.filter((_, i) => i !== index)
                          )
                        }}
                        disabled={loading}
                      >
                        <Delete />
                      </IconButton>
                    </Stack>
                  ))}
                </Stack>
              </AccordionDetails>
              <AccordionActions>
                {pulseValues.length < 10 && (
                  <Button
                    variant='contained'
                    onClick={() =>
                      setPulseHeaders([...pulseHeaders, { ...headerTemplate }])
                    }
                    disabled={loading}
                    startIcon={<Add />}
                  >
                    Add Header
                  </Button>
                )}
              </AccordionActions>
            </Accordion>

            <Divider component='div' sx={{ width: '100%' }} />
            <h4>Pulse Sections</h4>
            <Button onClick={() => setAllExpand(!allExpand)} size='small'>
              {allExpand ? 'Collapse All' : 'Expand All'}
            </Button>

            {isEdit && (
              <Alert severity='error' sx={{ width: '100%' }}>
                Changing sections can cause issues with existing responses and
                data.
              </Alert>
            )}
            {pulseSections.map((section, index) => (
              <PulseSectionInputs
                key={section.id + '_accordion'}
                section={section}
                index={index}
                pulseHeaders={pulseHeaders}
                isEdit={isEdit}
                pulseSections={pulseSections}
                setPulseSections={setPulseSections}
                loading={loading}
                imageRefs={imageRefs}
                abImageRefs={abImageRefs}
                handleABImageChange={handleABImageChange}
                handleImageChange={handleImageChange}
                sectionImages={sectionImages}
                handleImageAltChange={handleImageAltChange}
                handleImageRemove={handleImageRemove}
                handleABImageRemove={handleABImageRemove}
                handleSectionImageDelete={handleSectionImageDelete}
                pulseValues={pulseValues}
                setPulseValues={setPulseValues}
                showSubmitModal={showSubmitModal}
                allExpand={allExpand}
              />
            ))}

            {!!importAlert && (
              <Alert
                severity='error'
                sx={{ width: '100%' }}
                onClose={() => setImportAlert(null)}
              >
                {importAlert}
              </Alert>
            )}
            <Stack
              sx={{
                width: '100%',
                rowGap: 1,
                flexWrap: { xs: 'wrap', sm: 'nowrap' }
              }}
              spacing={1}
              direction='row'
            >
              {pulseSections.length === 1 && (
                <>
                  <Stack direction='row' spacing={1} justifyContent='center'>
                    <input
                      type='file'
                      accept='.csv'
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />

                    <Tooltip title='CSV template'>
                      <Button
                        disabled={loading}
                        startIcon={<Download />}
                        onClick={handleDownloadTemplate}
                      >
                        Template
                      </Button>
                    </Tooltip>
                    <Button
                      variant='contained'
                      disabled={loading}
                      sx={{ width: '150px' }}
                      startIcon={<UploadFile />}
                      onClick={handleButtonClick}
                    >
                      Import CSV
                    </Button>
                  </Stack>
                </>
              )}
              <Stack
                direction='row'
                spacing={1}
                sx={{ width: '100%' }}
                justifyContent={
                  pulseSections.length > 1 ? 'space-between' : 'flex-end'
                }
              >
                {pulseSections.length > 1 && (
                  <Tooltip title='Reset All Sections'>
                    <Button
                      disabled={loading}
                      color='error'
                      startIcon={<Refresh />}
                      onClick={() => {
                        handleAllDelete()
                      }}
                    >
                      Reset
                    </Button>
                  </Tooltip>
                )}
                <Button
                  variant='contained'
                  onClick={() =>
                    setPulseSections([
                      ...pulseSections,
                      { ...sectionTemplate() }
                    ])
                  }
                  disabled={loading}
                  startIcon={<Add />}
                >
                  Add Section
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Card>
        <Card raised sx={{ width: '100%', maxWidth: 'min(1000px, 95%)' }}>
          <CardHeader title='Configuration' />

          <Stack
            direction='column'
            justifyContent='center'
            alignItems='center'
            spacing={2}
            sx={{ width: '97%', m: 'auto', pb: 2 }}
          >
            <h5>Other Admins</h5>

            <span className='caption' style={{ mt: '8px !important' }}>
              Press enter after entering each email, copy and paste a list, or
              add a team.
            </span>
            <MultiEmailComponent
              emails={adminEmails}
              setEmails={setAdminEmails}
              placeholder='Admin Emails'
            />

            {teams.length > 0 && (
              <Autocomplete
                multiple
                id='tags-outlined'
                options={teams}
                getOptionLabel={team => (
                  <>
                    <b>{team.teamName}</b>
                    <p className='teamOptionDropdown'>
                      ({team.emails.filter(val => val !== userEmail).join(', ')}
                      )
                    </p>
                  </>
                )}
                defaultValue={[]}
                filterSelectedOptions
                disabled={loading}
                fullWidth
                value={selectedTeams}
                onChange={handleChangeSelectedTeams}
                renderInput={params => (
                  <TextField {...params} label='Teams' placeholder='Teams' />
                )}
              />
            )}

            {teams.length === 0 && (
              <span className='caption' style={{ mt: '8px !important' }}>
                Create teams on the profile tab
              </span>
            )}

            <Divider component='div' sx={{ width: '100%' }} />
            <h5>Visible Dates*</h5>
            {isEdit && (
              <span
                className='caption'
                style={{ mt: '8px !important', fontWeight: 'bold' }}
              >
                {`Duration must be ${minQuantity} days or longer.`}
              </span>
            )}
            <p
              className='caption'
              style={{
                mt: '8px !important',
                color:
                  minQuantity !== null
                    ? quantityOfDates(state[0].startDate, state[0].endDate) <
                      minQuantity
                      ? 'red'
                      : 'green'
                    : '',
                fontWeight: 'bold'
              }}
            >
              {`Selected Duration: ${quantityOfDates(
                state[0].startDate,
                state[0].endDate
              )} days`}
            </p>

            <p
              className='caption'
              style={{
                margin: '8px',
                fontStyle: 'italic',
                textAlign: 'center'
              }}
            >
              {`Start date cannot be changed after submission and duration cannot be shortened after payment.`}
              <br />
              {!noPaymentNeeded && requirePayments && (
                <Link
                  href={window.location.origin + '/support/contact'}
                  target='_blank'
                  rel='noreferrer'
                >{`Contact us, with questions or to work out another price structure!`}</Link>
              )}
            </p>

            <Box className='dateRange'>
              <DateRange
                editableDateInputs={true}
                onChange={item => {
                  if (minQuantity !== null) {
                    item.selection.startDate = state[0].startDate
                    setState([item.selection])
                    setState2([item.selection])
                  } else {
                    setState([item.selection])
                    setState2([item.selection])
                  }
                }}
                moveRangeOnFirstSelection={false}
                ranges={state}
                endDatePlaceholder='Not Set'
              />
            </Box>
            <Divider component='div' sx={{ width: '100%' }} />

            <Stack direction='row' alignItems='center'>
              <h5 style={{ margin: '0' }}>Allow Responses</h5>
              <Switch
                checked={useComments}
                onChange={() => {
                  setUseComments(!useComments)
                }}
              />
            </Stack>
            {useComments && (
              <>
                {isEdit && (
                  <p className='caption' style={{ margin: '0', color: 'red' }}>
                    <i>
                      Turning off responses while editing will delete all
                      comments.
                    </i>
                  </p>
                )}
                <span className='caption' style={{ fontWeight: 'bold' }}>
                  Response Dates (Must be between Visible Dates)
                </span>
                <Box className='dateRange'>
                  <DateRange
                    editableDateInputs={true}
                    onChange={changeDate2}
                    moveRangeOnFirstSelection={false}
                    ranges={state2}
                    endDatePlaceholder='Not Set'
                  />
                </Box>
                <Button
                  size='small'
                  onClick={matchDates}
                  disabled={loading}
                  startIcon={<ContentCopy />}
                >
                  All Visible Dates
                </Button>

                <TextField
                  id='setCommentVisibility'
                  select
                  disabled={loading}
                  size='small'
                  label='Comment Visibility'
                  fullWidth
                  variant='outlined'
                  value={commentVisibility}
                  onChange={event => setCommentVisibility(event.target.value)}
                >
                  <MenuItem key={'own'} value={false}>
                    Users can only see their own comments
                  </MenuItem>
                  <MenuItem key={'everyone'} value={true}>
                    Users can see everyone's comments
                  </MenuItem>
                </TextField>
              </>
            )}
            <Divider component='div' sx={{ width: '100%' }} />

            {customRoute.length > 0 && (
              <span
                className='caption'
                style={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                URL Preview:{' '}
                {window.location.origin +
                  '/viewPulse/' +
                  customRoute.toLowerCase()}
              </span>
            )}
            <TextField
              id='customURL'
              variant='outlined'
              label='Custom URL'
              onChange={handleCustomRoute}
              value={customRoute}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='start'>
                    {customRouteVerified && customRoute.length > 0 ? (
                      <Tooltip title={'This URL is available.'}>
                        <Verified color='success' />
                      </Tooltip>
                    ) : customRoute.length > 0 ? (
                      <Tooltip title={'This URL is taken.'}>
                        <ReportGmailerrorred color='error' />
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                  </InputAdornment>
                )
              }}
              disabled={loading}
              fullWidth
              sx={{ mr: 2 }}
              inputProps={{ maxLength: 25 }}
              error={customRoute.length > 0 && !customRouteVerified}
            />
            <TextField
              id='thankYouMessage'
              variant='outlined'
              label='Thank You Message'
              placeholder='Thank you for responding to this Pulse! Feel free to change your responses or leave comments within each section.'
              onChange={e => {
                setThankYouMessage(e.target.value)
              }}
              value={thankYouMessage}
              disabled={loading}
              fullWidth
            />
            <Divider component='div' sx={{ width: '100%' }} />
            <Stack direction='row' alignItems='center'>
              <h5 style={{ margin: '0' }}>Access Code</h5>
              <Switch
                checked={useViewCode}
                onChange={() => {
                  setUseViewCode(!useViewCode)
                }}
              />
            </Stack>
            {useViewCode && (
              <Stack direction='row' alignItems='center' sx={{ width: '100%' }}>
                <TextField
                  id='code'
                  variant='outlined'
                  label='Access Code'
                  onChange={handleCode}
                  value={viewCode}
                  disabled={loading}
                  fullWidth
                  sx={{ mr: 2 }}
                  inputProps={{ maxLength: 20 }}
                />
                <IconButton
                  variant='outlined'
                  onClick={() => {
                    setViewCode(makeid(6))
                  }}
                  disabled={loading}
                >
                  <RestartAlt />
                </IconButton>
              </Stack>
            )}
            <Divider component='div' sx={{ width: '100%' }} />
            <Stack spacing={3} sx={{ width: '100%' }}>
              <TextField
                id='setSearchable'
                select
                size='small'
                label='Searchable'
                fullWidth
                disabled={loading}
                variant='outlined'
                value={searchable}
                onChange={event => setSearchable(event.target.value)}
              >
                <MenuItem key={'own'} value={false}>
                  Not Searchable by Public
                </MenuItem>
                <MenuItem key={'everyone'} value={true}>
                  Searchable by Public
                </MenuItem>
              </TextField>
              <TextField
                id='setSignInView'
                select
                size='small'
                label='Pulse Permissions'
                fullWidth
                disabled={loading}
                variant='outlined'
                value={signInView}
                onChange={event => setSignInView(event.target.value)}
              >
                <MenuItem key={'own'} value={false}>
                  Not Required to Sign In to View Pulse
                </MenuItem>
                <MenuItem key={'everyone'} value={true}>
                  Required to Sign In to View Pulse
                </MenuItem>
              </TextField>
            </Stack>
          </Stack>
        </Card>

        <Card
          raised
          sx={{
            width: '100%',
            maxWidth: 'min(1000px, 95%)',
            position: 'sticky',
            bottom: 0,
            zIndex: 10,
            bottom: 16
          }}
        >
          <Stack
            direction='row'
            justifyContent='center'
            alignItems='center'
            spacing={1}
            sx={{ width: '97%', m: 'auto', pb: 2, pt: 2 }}
          >
            {isEdit && document.uid === uid && (
              <>
                <Button
                  size='small'
                  id='basic-button'
                  aria-controls={openMenu ? 'basic-menu' : undefined}
                  aria-haspopup='true'
                  aria-expanded={openMenu ? 'true' : undefined}
                  onClick={handleOpenMenu}
                  disabled={loading}
                  sx={{ minWidth: 'unset' }}
                >
                  <MoreVert />
                </Button>
                <Menu
                  id='basic-menu'
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleOpenMenuClose}
                  slotProps={{
                    list: {
                      'aria-labelledby': 'basic-button'
                    }
                  }}
                >
                  <MenuItem
                    onClick={() =>
                      window
                        .open(
                          window.location.origin + '/copyPulse/' + document.id,
                          '_blank'
                        )
                        .focus()
                    }
                  >
                    <ContentCopy sx={{ mr: 1 }} />
                    Copy Configuration
                  </MenuItem>

                  <ListSubheader>Dangerous:</ListSubheader>
                  <MenuItem
                    onClick={e => {
                      handleOpenMenuClose(e)
                      setShowDeleteResponsesModal(true)
                    }}
                    color='error'
                  >
                    <CommentsDisabled sx={{ mr: 1 }} />
                    Delete Responses
                  </MenuItem>
                  <MenuItem
                    onClick={e => {
                      handleOpenMenuClose(e)
                      setShowDeleteModal(true)
                    }}
                    color='error'
                  >
                    <Delete sx={{ mr: 1 }} />
                    Delete Project
                  </MenuItem>
                </Menu>
                <Dialog
                  open={showDeleteResponsesModal}
                  onClose={() => setShowDeleteResponsesModal(false)}
                  PaperComponent={PaperComponent}
                  aria-labelledby='draggable-dialog-title'
                >
                  <DialogTitle style={{ cursor: 'move' }}>
                    <Stack
                      direction='row'
                      style={{ gap: '10px' }}
                      alignItems='center'
                    >
                      Deleting Responses is Permanent!
                    </Stack>
                  </DialogTitle>
                  <DialogContent>
                    You will not be able to revert this action. As soon as you
                    press DELETE FOREVER, the responses will be deleted.
                    <br />
                    Download your report before deleting responses.
                    <DownloadButton
                      document={document}
                      icon={false}
                      db={db}
                      isPulse={true}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={handleRemoveResponses}
                      color='error'
                      variant='contained'
                      disabled={loading}
                    >
                      Delete Forever
                    </Button>
                    <Button
                      disabled={loading}
                      onClick={() => setShowDeleteResponsesModal(false)}
                      variant='contained'
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  open={showDeleteModal}
                  onClose={() => setShowDeleteModal(false)}
                  PaperComponent={PaperComponent}
                  aria-labelledby='draggable-dialog-title'
                >
                  <DialogTitle style={{ cursor: 'move' }}>
                    <Stack
                      direction='row'
                      style={{ gap: '10px' }}
                      alignItems='center'
                    >
                      Deleting this Project is Permanent!
                    </Stack>
                  </DialogTitle>
                  <DialogContent>
                    You will not be able to revert this action.
                    <br /> Download your report before deleting.
                    <DownloadButton
                      document={document}
                      icon={false}
                      db={db}
                      isPulse={true}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={handleRemoveDoc}
                      color='error'
                      variant='contained'
                      disabled={loading}
                    >
                      Delete Forever
                    </Button>
                    <Button
                      disabled={loading}
                      onClick={() => setShowDeleteModal(false)}
                      variant='contained'
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
            <Button
              variant='contained'
              disabled={loading}
              onClick={() => navigate('/dashboard')}
              sx={{ ml: 'auto !important' }}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              color='success'
              onClick={() => setShowSubmitModal(true)}
              startIcon={<PostAdd />}
            >
              {loading
                ? 'Submitting...'
                : 'Submit' + (isEdit && !isDraft ? ' Edits' : '')}
            </Button>

            <Dialog
              open={showSubmitModal}
              onClose={() => setShowSubmitModal(false)}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby='draggable-dialog-title'
            >
              <DialogTitle style={{ cursor: 'move' }}>
                Ready to {'Submit' + (isEdit && !isDraft ? ' Edits?' : '?')}
              </DialogTitle>
              <DialogContent>
                {!areSectionsValid && (
                  <Alert
                    severity='error'
                    sx={{
                      width: '100%',
                      maxWidth: 'min(1000px, 95%)',
                      margin: 'auto !important'
                    }}
                  >
                    Sections are not valid. Please make sure to fill in all
                    required fields. A title is required for every section.
                    {pulseSections.some(section => section.isABTesting) && (
                      <>
                        <br />
                        Option Text must be unique for A/B Testing
                      </>
                    )}
                    {pulseSections.some(
                      section => section.isMultipleChoice
                    ) && (
                      <>
                        <br />
                        Column Text must be unique for Multiple Choice Grid
                      </>
                    )}
                    {pulseSections.some(section => section.isChoice) && (
                      <>
                        <br />
                        Choice Text must be unique for Multiple Choice
                      </>
                    )}
                  </Alert>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setShowSubmitModal(false)}
                  variant='contained'
                >
                  Cancel
                </Button>
                <Button
                  onClick={isEdit && !isCopy ? editDoc : submitDoc}
                  variant='contained'
                  color='success'
                  startIcon={<PostAdd />}
                  disabled={
                    fileName === '' ||
                    displayName === '' ||
                    state[0].endDate === '' ||
                    (useComments &&
                      (state2[0].startDate < state[0].startDate ||
                        state2[0].endDate > state[0].endDate)) ||
                    (useViewCode && viewCode === '') ||
                    loading ||
                    (minQuantity !== null &&
                      quantityOfDates(state[0].startDate, state[0].endDate) <
                        minQuantity) ||
                    (customRoute.length > 0 && !customRouteVerified) ||
                    !pulseSectionsAreValid() ||
                    pulseValues.length < 2 ||
                    pulseValues.some(val => val.length < 1)
                  }
                >
                  {'Submit' + (isEdit && !isDraft ? ' Edits' : '')}
                </Button>
              </DialogActions>
            </Dialog>
          </Stack>
        </Card>

        <Dialog
          open={showHelp}
          onClose={() => setShowHelp(false)}
          PaperComponent={PaperComponent}
          aria-labelledby='draggable-dialog-title'
          fullWidth
          maxWidth={'md'}
        >
          <DialogTitle>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: 'primary.main'
              }}
            >
              <HowToVote /> Upload a Pulse
            </Box>
          </DialogTitle>
          <DialogContent>
            <AdminHelpPulse showTitle={false} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowHelp(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </div>
  )
}

export default UploadPulse
